/**
 * *************************
 * Action Types
 * *************************
 */
export const actions = {
  applePayAvailable: 'applePayAvailable',
  changeTab: 'changeTab',
  checkoutFailure: 'checkoutFailure',
  continueAsGuest: 'continueAsGuest',
  connectAddressFailure: 'connectAddressFailure',
  connectAddressRequest: 'connectAddressRequest',
  connectAddressSuccess: 'connectAddressSuccess',
  createAddressFailure: 'createAddressFailure',
  createAddressRequest: 'createAddressRequest',
  createAddressSuccess: 'createAddressSuccess',
  createBillingInfoFailure: 'createBillingInfoFailure',
  createBillingInfoRequest: 'createBillingInfoRequest',
  createBillingInfoSuccess: 'createBillingInfoSuccess',
  createGuestOrderFailure: 'createGuestOrderFailure',
  createGuestOrderRequest: 'createGuestOrderRequest',
  createGuestOrderSuccess: 'createGuestOrderSuccess',
  createKlarnaSessionRequest: 'createKlarnaSessionRequest',
  createKlarnaSessionSuccess: 'createKlarnaSessionSuccess',
  createKlarnaSessionFailure: 'createKlarnaSessionFailure',
  createPayPalSessionRequest: 'createPayPalSessionRequest',
  createPayPalSessionSuccess: 'createPayPalSessionSuccess',
  createPayPalSessionFailure: 'createPayPalSessionFailure',
  deleteAddressFailure: 'deleteAddressFailure',
  deleteAddressRequest: 'deleteAddressRequest',
  deleteAddressSuccess: 'deleteAddressSuccess',
  displayGlobalError: 'displayGlobalError',
  dismissExpressPayModal: 'dismissExpressPayModal',
  dismissGlobalError: 'dismissGlobalError',
  dismissInternationalFeeWarning: 'dismissInternationalFeeWarning',
  expressCheckoutFailure: 'expressCheckoutFailure',
  expressCheckoutRequest: 'expressCheckoutRequest',
  fetchAddressFailure: 'fetchAddressFailure',
  fetchAddressRequest: 'fetchAddressRequest',
  fetchAddressSuccess: 'fetchAddressSuccess',
  fetchAddressesFailure: 'fetchAddressesFailure',
  fetchAddressesRequest: 'fetchAddressesRequest',
  fetchAddressesSuccess: 'fetchAddressesSuccess',
  fetchAvailablePaymentMethodsFailure: 'fetchAvailablePaymentMethodsFailure',
  fetchAvailablePaymentMethodsRequest: 'fetchAvailablePaymentMethodsRequest',
  fetchAvailablePaymentMethodsSuccess: 'fetchAvailablePaymentMethodsSuccess',
  fetchBillingInfoFailure: 'fetchBillingInfoFailure',
  fetchBillingInfoRequest: 'fetchBillingInfoRequest',
  fetchBillingInfoSuccess: 'fetchBillingInfoSuccess',
  fetchBillingInfosFailure: 'fetchBillingInfosFailure',
  fetchBillingInfosRequest: 'fetchBillingInfosRequest',
  fetchBillingInfosSuccess: 'fetchBillingInfosSuccess',
  fetchCreditCardSuccess: 'fetchCreditCardSuccess',
  fetchGiftCardFailure: 'fetchGiftCardFailure',
  fetchGiftCardRequest: 'fetchGiftCardRequest',
  fetchGiftCardSuccess: 'fetchGiftCardSuccess',
  fetchOrderFailure: 'fetchOrderFailure',
  fetchOrderRequest: 'fetchOrderRequest',
  fetchOrderSuccess: 'fetchOrderSuccess',
  // CHECKOUT TODO: payment method actions may be duplication of billing info need to verify
  fetchPaymentMethodFailure: 'fetchPaymentMethodFailure',
  fetchPaymentMethodRequest: 'fetchPaymentMethodRequest',
  fetchPaymentMethodSuccess: 'fetchPaymentMethodSuccess',
  fetchGuestPriceEstimateFailure: 'fetchGuestPriceEstimateFailure',
  fetchGuestPriceEstimateRequest: 'fetchGuestPriceEstimateRequest',
  fetchGuestPriceEstimateSuccess: 'fetchGuestPriceEstimateSuccess',
  fetchGuestPriceBreakdownFailure: 'fetchGuestPriceBreakdownFailure',
  fetchGuestPriceBreakdownRequest: 'fetchGuestPriceBreakdownRequest',
  fetchGuestPriceBreakdownSuccess: 'fetchGuestPriceBreakdownSuccess',
  fetchPriceEstimateSuccess: 'fetchPriceEstimateSuccess',
  fetchProductTemplateFailure: 'fetchProductTemplateFailure',
  fetchProductTemplateRequest: 'fetchProductTemplateRequest',
  fetchProductTemplateSuccess: 'fetchProductTemplateSuccess',
  fetchPromotionFailure: 'fetchPromotionFailure',
  fetchPromotionSuccess: 'fetchPromotionSuccess',
  fetchWantFailure: 'fetchWantFailure',
  fetchWantRequest: 'fetchWantRequest',
  fetchWantSuccess: 'fetchWantSuccess',
  orderFromQueryParamsSuccess: 'orderFromQueryParamsSuccess',
  sectionEdit: 'sectionEdit',
  sectionUpdate: 'sectionUpdate',
  promotionLoading: 'promotionLoading',
  purchaseOrderFailure: 'purchaseOrderFailure',
  purchaseOrderRequest: 'purchaseOrderRequest',
  sessionTimeoutFailure: 'sessionTimeoutFailure',
  updateOrderFailure: 'updateOrderFailure',
  updateOrderRequest: 'updateOrderRequest',
  updateOrderSuccess: 'updateOrderSuccess',
  updateShippingServiceLevelFailure: 'updateShippingServiceLevelFailure',
  updateShippingServiceLevelRequest: 'updateShippingServiceLevelRequest',
  updateShippingServiceLevelSuccess: 'updateShippingServiceLevelSuccess',
  userTypeUpdate: 'userTypeUpdate',
  verifyCreditCardFailure: 'verifyCreditCardFailure',
  verifyCreditCardRequest: 'verifyCreditCardRequest',
  verifyCreditCardSuccess: 'verifyCreditCardSuccess',
};
